// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__aBJgR","primary":"Button_primary__6KSJ_","outline":"Button_outline__foIFY","ghost":"Button_ghost__Rym_9"};